import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Building2, Lock } from "lucide-react";

export default function VendorClaim() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (pwd.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (pwd !== pwd2) { toast.error("Passwords don't match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/vendor/claim", { token, password: pwd });
      await refresh();
      toast.success("Account claimed. Continue your onboarding.");
      nav("/vendor/onboarding", { replace: true });
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="vendor-claim-page">
      <div className="w-full max-w-md card-flat p-8">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-[#F54800]/10 text-[#F54800] mb-4"><Building2 size={20} /></div>
        <h1 className="font-display text-2xl text-slate-900 mb-1">Welcome to Analogy Studio</h1>
        <p className="text-sm text-slate-500 mb-6">Set your password to start your vendor onboarding. You&apos;ll save your details, sign the NDA, then submit for review.</p>
        <div className="space-y-3">
          <div><Label className="label-overline">Choose a password</Label><Input type="password" className="rounded-sm mt-1" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Min 8 characters" data-testid="vendor-claim-pwd" /></div>
          <div><Label className="label-overline">Confirm password</Label><Input type="password" className="rounded-sm mt-1" value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="vendor-claim-pwd2" /></div>
          <Button onClick={submit} disabled={saving} className="w-full rounded-sm bg-[#F54800] hover:bg-[#D63E00] text-white" data-testid="vendor-claim-submit">
            <Lock size={13} className="mr-1.5" />{saving ? "Setting up…" : "Set password & continue"}
          </Button>
        </div>
        <p className="text-[10px] text-slate-400 mt-6 text-center">This is a one-time link. Need help? Reply to the email you got.</p>
      </div>
    </div>
  );
}
